module.exports = __webpack_public_path__ + "assets/img/800b2d8763675aad39f3ead6bed4166d.png";